// Browse Abandonment Popup - Category Visit Tracking
console.log('🔍 BROWSE ABANDONMENT LOADED');



class BrowseAbandonmentTracker {
  constructor() {
    this.storageKey = 'browse_abandonment_data';
    this.popupShownKey = 'browse_abandonment_shown';
    this.settings = window.browseAbandonmentSettings || {};
    this.categoryThreshold = this.settings.categoryThreshold || 3;
    this.init();
  }

  init() {
    // Don't run if this popup already shown
    if (sessionStorage.getItem(this.popupShownKey)) return;
    
    this.trackPageVisit();
    this.checkForAbandonmentTrigger();
  }

  trackPageVisit() {
    const currentPage = window.location.pathname;
    const isCollection = currentPage.includes('/collections/') && !currentPage.includes('/products/');
    const isProduct = currentPage.includes('/products/');
    
    let data = this.getData();
    
    if (isCollection) {
      data.categoryVisits++;
      data.lastActivity = Date.now();
      console.log(`📂 Category visit #${data.categoryVisits}`);
    } else if (isProduct) {
      // Reset if they view a product
      data = this.resetData();
      console.log('🛍️ Product viewed - resetting tracker');
    }
    
    this.saveData(data);
  }

  checkForAbandonmentTrigger() {
    const data = this.getData();
    
    if (data.categoryVisits >= this.categoryThreshold) {
      console.log(`🚨 Abandonment trigger: ${data.categoryVisits} category visits`);
      setTimeout(() => this.showPopup(), 2000); // Small delay for better UX
    }
  }

  getData() {
    const stored = localStorage.getItem(this.storageKey);
    return stored ? JSON.parse(stored) : {
      categoryVisits: 0,
      lastActivity: Date.now()
    };
  }

  saveData(data) {
    localStorage.setItem(this.storageKey, JSON.stringify(data));
  }

  resetData() {
    const newData = {
      categoryVisits: 0,
      lastActivity: Date.now()
    };
    this.saveData(newData);
    return newData;
  }

  showPopup() {
    // Check if another popup is currently active
    if (!window.popupManager?.canShow('browse_abandonment')) return;
    
    // Mark as active and shown
    window.popupManager.setActive('browse_abandonment');
    sessionStorage.setItem(this.popupShownKey, 'true');
    
    const popup = document.createElement('div');
    popup.innerHTML = `
      <div style="position: fixed; top: 0; left: 0; width: 100vw; height: 100vh; background: rgba(0,0,0,0.5); z-index: 99999; display: flex; justify-content: center; align-items: center;">
        <div style="background: white; padding: 40px; border-radius: 8px; max-width: 480px; width: 90%; text-align: center; position: relative;">
          <button onclick="this.closest('div').parentElement.remove(); window.popupManager?.clearActive();" style="position: absolute; top: 16px; right: 16px; background: none; border: none; font-size: 24px; cursor: pointer;">&times;</button>
          
          <h2 style="margin-bottom: 24px; color: #333; font-size: 24px;">${this.settings.title || 'Having trouble finding what you need?'}</h2>
          
          <form id="abandonment-form" style="text-align: left;">
            <div style="margin-bottom: 20px;">
              ${this.generateOptionsHTML()}
            </div>
            
            <div id="followup-section" style="display: none; margin-bottom: 20px;">
              <label style="display: block; margin-bottom: 8px; font-weight: 500;">How can we help you find the perfect piece?</label>
              <textarea name="additional_help" placeholder="Tell us more about what you're looking for..." style="width: 100%; height: 80px; padding: 12px; border: 1px solid #ddd; border-radius: 4px; resize: vertical;"></textarea>
            </div>
            
            <button type="submit" style="width: 100%; padding: 14px; background: #333; color: white; border: none; border-radius: 4px; font-size: 16px; font-weight: 600; cursor: pointer; margin-bottom: 12px;">Get Personalized Help & 10% OFF</button>
            
            <button type="button" onclick="this.closest('div').parentElement.remove(); window.popupManager?.clearActive();" style="background: none; border: none; color: #666; font-size: 14px; text-decoration: underline; cursor: pointer;">Continue browsing</button>
          </form>
          
          <div id="help-section" style="display: none; padding: 20px; border: 2px dashed #333; border-radius: 4px; background: #f9f9f9; text-align: center;">
            <div style="margin-bottom: 12px; font-size: 18px;"><strong>Thanks for sharing! Here's your 10% OFF: <span style="padding: 4px 8px; background: #333; color: white; border-radius: 4px; font-family: monospace; font-weight: bold;">${this.settings.coupon || 'HELP10'}</span></strong></div>
            <p style="margin: 8px 0; color: #666; font-size: 14px;">Code copied to clipboard! Our team will reach out with personalized recommendations.</p>
            <p style="margin: 0; color: #666; font-size: 12px;">We'll email you within 24 hours with curated suggestions based on your preferences.</p>
          </div>
        </div>
      </div>
    `;
    
    document.body.appendChild(popup);
    
    // Add event listeners
    const form = popup.querySelector('#abandonment-form');
    const followupSection = popup.querySelector('#followup-section');
    const helpSection = popup.querySelector('#help-section');
    
    // Radio button change handler
    popup.querySelectorAll('input[name="browse_issue"]').forEach(radio => {
      radio.addEventListener('change', () => {
        followupSection.style.display = 'block';
      });
    });
    
    // Form submit handler
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      
      const formData = new FormData(form);
      const data = {
        browse_issue: formData.get('browse_issue'),
        additional_help: formData.get('additional_help') || null,
        category_visits: this.getData().categoryVisits,
        timestamp: new Date().toISOString(),
        page_url: window.location.href,
        popup_type: 'browse_abandonment'
      };
      
      console.log('💾 Saving abandonment data:', data);
      
      // Save to Supabase - use same endpoint as entry popup
      try {
        const response = await fetch('https://qroltylejgxqrcpvppqi.supabase.co/rest/v1/browse_abandonment_responses', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'apikey': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFyb2x0eWxlamd4cXJjcHZwcHFpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAyNTM1NjAsImV4cCI6MjA3NTgyOTU2MH0.soH2wO5kEnkQj4RMMFGyaKrTQmub4zKXTpNNXbQY9oI',
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFyb2x0eWxlamd4cXJjcHZwcHFpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjAyNTM1NjAsImV4cCI6MjA3NTgyOTU2MH0.soH2wO5kEnkQj4RMMFGyaKrTQmub4zKXTpNNXbQY9oI',
            'Prefer': 'return=minimal'
          },
          body: JSON.stringify(data)
        });
        
        if (response.ok) {
          console.log('✅ Abandonment data saved');
        } else {
          console.log('❌ Save failed:', response.status);
        }
      } catch (error) {
        console.log('❌ Error:', error);
      }
      
      // Show help section
      form.style.display = 'none';
      helpSection.style.display = 'block';
      
      // Copy coupon to clipboard
      navigator.clipboard.writeText(this.settings.coupon || 'HELP10').catch(() => console.log('Clipboard copy failed'));
      
      // Reset tracking data
      this.resetData();
      
      // Auto close after 8 seconds
      setTimeout(() => {
        popup.remove();
        window.popupManager?.clearActive();
      }, 8000);
    });
    
    console.log('🚨 Browse abandonment popup shown');
  }

  generateOptionsHTML() {
    const options = this.settings.options || [
      'Not sure what style suits me',
      'Looking for specific occasion jewelry', 
      'Checking quality/materials first',
      'Comparing with other brands',
      'Just browsing for now'
    ];
    
    return options.map((option, index) => {
      const value = option.toLowerCase().replace(/[^a-z0-9]/g, '_');
      return `
        <label style="display: flex; align-items: center; padding: 12px; margin-bottom: 8px; border: 1px solid #ddd; border-radius: 4px; cursor: pointer;">
          <input type="radio" name="browse_issue" value="${value}" style="margin-right: 12px;">
          <span>${option}</span>
        </label>
      `;
    }).join('');
  }
}

// Initialize tracker when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new BrowseAbandonmentTracker();
  });
} else {
  new BrowseAbandonmentTracker();
}